import React, { ReactNode } from 'react';

import { mobileOnly } from 'styles/mixins/displayMobileDesktop';
import { CtaButton } from 'components/global/CtaButton';
import { trackEvent } from 'utils/metricsTracking';
import { EVENTS } from 'consts/metricsTrackingEvents';
import { navExternalWithQueryString } from 'utils/marketingSafeDomain';

import { SubsectionContainer, buttonStyles } from './Subsection.style';
import {
  HeroImage,
  SubsectionHeader,
  Cards,
  ModuleNameContext,
} from './components';
import { type ProductCardProps } from './components/Cards/components/ProductCards/components';

export interface AccentImage {
  name?: string;
  image: {
    desktop: ReactNode;
    mobile?: ReactNode;
  };
}

export interface SubsectionProps {
  moduleName: string;
  title?: string;
  subtitle?: ReactNode;
  ctaButtonText?: string;
  ctaECommerceLink?: string;
  accentImage?: AccentImage;
  productCards: ProductCardProps[];
  productCardCtaText?: string;
}

export const Subsection = ({ content }: { content: SubsectionProps }) => {
  const { ctaButtonText, ctaECommerceLink, moduleName, accentImage } = content;

  const handleECommerceClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    trackEvent(EVENTS.ctaClicked, { module: moduleName });
    navExternalWithQueryString(ctaECommerceLink);
  };

  return (
    <ModuleNameContext.Provider value={moduleName}>
      <SubsectionContainer data-module={moduleName}>
        {accentImage && <HeroImage content={accentImage} />}
        <SubsectionHeader content={content} />
        <Cards content={content} />
        {ctaButtonText && (
          <CtaButton
            buttonText={ctaButtonText}
            module={moduleName}
            css={[buttonStyles, mobileOnly()]}
            {...(ctaECommerceLink && { onClick: handleECommerceClick })}
          />
        )}
      </SubsectionContainer>
    </ModuleNameContext.Provider>
  );
};
